import account from 'Routes/account'
import auth from 'Routes/auth'
import errors from 'Routes/errors'
import home from 'Routes/home'

//Admin Routes
import admin from 'Routes/admin.js'

const routeFiles = []
/* Multi Route Files */
const routes = routeFiles.concat(
  account,
  auth,
  errors,
  home,
  admin
  /* add here Other Routes File */
)
export default routes



// WEBPACK FOOTER //
// ./resources/js/routes/index.js